var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifyEmailImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.156 7.82911C8.17276 7.82911 5.05509 8.83569 4.5048 12.6642C4.32855 13.8901 4.7163 15.0965 5.60734 15.9679C6.04993 16.3988 6.51797 16.9158 7.1368 17.4367C8.68976 18.7468 10.6696 20.2175 12.5222 21.5374C17.6198 25.1604 21.6441 27.4124 24.0274 27.4124C26.4107 27.4124 30.4351 25.1604 35.5326 21.5374C37.3872 20.2195 39.3671 18.7449 40.9181 17.4367C41.5369 16.9158 42.0049 16.4027 42.4475 15.9679C42.8809 15.5447 43.207 15.0242 43.3987 14.4496C43.5905 13.875 43.6424 13.2629 43.55 12.6642C43.0017 8.83569 39.8821 7.82715 35.8988 7.82715L12.156 7.82911ZM4.44409 19.8846V31.3291C4.44409 33.4066 5.26939 35.3991 6.73842 36.8681C8.20746 38.3372 10.1999 39.1624 12.2774 39.1624H35.7774C37.855 39.1624 39.8474 38.3372 41.3164 36.8681C42.7855 35.3991 43.6108 33.4066 43.6108 31.3291V19.8846C41.7585 21.6632 39.775 23.2997 37.677 24.7804C32.1212 28.7128 27.1333 31.3291 24.0274 31.3291C20.9215 31.3291 15.9336 28.7128 10.3798 24.7804C8.28143 23.3002 6.29787 21.6636 4.44605 19.8846H4.44409Z",
    fill: "url(#paint0_linear_1_5750)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5750",
    x1: 37.5929,
    y1: 34.3678,
    x2: 16.3703,
    y2: 7.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1977F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#65A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFD2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyEmailImage);
export default __webpack_public_path__ + "static/media/verifyEmailImage.c2966f85.svg";
export { ForwardRef as ReactComponent };